// @flow
import * as React from 'react';

import { Box } from '@sonyged/proc-ui';
import css from '@styled-system/css';
import styled from 'styled-components';
import { AvatarContext } from '@sonyged/ext-proc';

import Avatar1 from '../../assets/images/pages/sushi/sushi_comment_1@3x.png';
import Avatar2 from '../../assets/images/pages/sushi/sushi_comment_2@3x.png';
import Avatar3 from '../../assets/images/pages/sushi/sushi_comment_3@3x.png';

type Props = {
  longText?: boolean,
  children: React.Node,
};

const Container = styled(Box)`
  position: absolute;
  z-index: 1000;
  bottom: 0;
  right: 0;
  left: 16px;

  display: flex;
  flex-direction: row-reverse;
`;

const Avatar = styled.img`
  flex-shrink: 0;
  align-self: flex-end;
  width: 64px;
  height: 80px;
  ${css({
    width: [64, null, 96],
    height: [80, null, 120],
  })};
`;

const Message = styled(Box)`
  ${css({
    backgroundColor: 'secondary30',
    color: 'gray100',
    fontSize: ['mobile.medium', 'smallPC.medium', '21px'],
    padding: ['8px 10px', null, '11px 10px'],
    margin: '12px 0',
    marginRight: ['8px', null, '13px'],
    maxWidth: [null, null, '334px'],
  })};
  position: relative;
  align-self: center;
  border-radius: 4px;

  ${props =>
    props.longText
      ? `
      @media screen and (max-width: 355px) {
        font-size: 16px;
      }
      @media screen and (max-width: 325px) {
        font-size: 14px;
      }
      `
      : ''};

  ::after {
    content: '';
    height: 0;
    width: 0;
    position: absolute;
    border-style: solid;
    border-color: transparent;
    ${css({
      borderLeftColor: 'secondary30',
      right: ['-16px', null, '-26px'],
      bottom: ['6px', null, '12px'],
      borderWidth: ['6px 8px', null, '10px 13px'],
    })};
  }
`;

const avatars = {
  '1': Avatar1,
  '2': Avatar2,
  '3': Avatar3,
};

export default React.forwardRef<Props, _>(function Comment({ children, longText = false }: Props, ref) {
  let avatar = React.useContext(AvatarContext) || 1;

  let src = avatars[avatar] || Avatar1;

  return (
    <Container ref={ref}>
      <Avatar src={src} alt="avatar" />
      <Message longText={longText}>{children}</Message>
    </Container>
  );
});
